import React from 'react'
import WhiteRight from '../../../../media/felsv/white_right-arrow_icon.svg'
import {useHistory} from 'react-router'
import {State} from '../../../../reducers'
import {useDispatch, useSelector} from 'react-redux'
import {generalOpenModalError, generalOpenModalInfo} from '../../../../actions/general.actions'
import {bindActionCreators} from 'redux'
import {actionSujetoExcluidoEmision} from '../../../../actions/action-creators'
import {sujetoExcluidoModalsOpenQuitarTodo} from '../../../../actions/sujeto-excluido/sujetoExcluidoProductos.actions'

const mensajeError = 'No existen productos para eliminar'

const SEFooter = () => {
  const history = useHistory()
  const {pagoCompletado} = useSelector((state: State) => state.formaPago)
  const arrayProductos = useSelector((state: State) => state.sujetoExcluido.arrayProductos)
  const dispatch = useDispatch()
  const {sujetoExcluidoClicGenerarFactura, sujetoExcluidoGetUUID} = bindActionCreators(actionSujetoExcluidoEmision, dispatch )

  const generarFactura = async () => {
    if (await sujetoExcluidoClicGenerarFactura()) {
      if(!pagoCompletado){
        dispatch(generalOpenModalInfo('El monto total de pago debe ser igual al total a pagar'))
        return
      }

      sujetoExcluidoGetUUID()
      history.push('/otros-documentos/sujeto-excluido/resumen')
    }
  }

  const openModalQuitarTodo = () => {
    if (arrayProductos.length === 0) return dispatch(generalOpenModalError(mensajeError))
    dispatch(sujetoExcluidoModalsOpenQuitarTodo())
  }

  return (
    <>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'space-between', width: '100%', }} >
        <button className='m button transparent botton-footer' onClick={openModalQuitarTodo}>
          <div>Quitar todo</div>
        </button>
        <button className='m button botton-footer' onClick={generarFactura}>
          <div>Siguiente</div>
          <img src={WhiteRight} loading='lazy' alt='Generar' />
        </button>
      </div>
    </>
  )
}

export default SEFooter
